module.exports = __webpack_public_path__ + "img/35.42cab9f0.png";